import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TestLink} from '../../data/models/test-link';

@Injectable({
  providedIn: 'root'
})
export class TestLinkService {

  constructor(
    private http: HttpClient,
  ) {
  }

  addTestLink(testId: number, data: {
    name: string,
    mail: string,
    startDate: string,
    finishDate: string,
    isMixedQuestions: boolean,
    isMixedOptions: boolean,
    allQuestionsRequired: boolean,
    trackTelegramUsers: boolean,
  }): Promise<TestLink> {

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('mail', data.mail);
    if (data.startDate.length === 10) {
      data.startDate += ' 00:00:00';
    }
    formData.append('startDate', new Date(data.startDate).toISOString());
    if (data.finishDate.length === 10) {
      data.finishDate += ' 23:59:59';
    }
    formData.append('finishDate', new Date(data.finishDate).toISOString());
    formData.append('isMixedQuestions', data.isMixedQuestions.toString());
    formData.append('isMixedOptions', data.isMixedOptions.toString());
    formData.append('allQuestionsRequired', data.allQuestionsRequired.toString());
    formData.append('trackTelegramUsers', data.trackTelegramUsers.toString());

    return this.http.post<TestLink>(`api/tests/${testId}/links`, formData)
      .toPromise();
  }

  getTestLinks(testId: number): Promise<TestLink[]> {
    return this.http.get<TestLink[]>(`api/tests/${testId}/links`)
      .toPromise();
  }

  deleteTestLink(testId: number, testLinkId: number): Promise<void> {
    return this.http.delete<void>(`api/tests/${testId}/links/${testLinkId}`)
      .toPromise();
  }

  editTestLink(testId: number, testLinkId: number, data: {
    name: string,
    startDate: string,
    finishDate: string,
    isMixedQuestions: boolean,
    isMixedOptions: boolean,
    allQuestionsRequired: boolean,
    trackTelegramUsers: boolean,
  }): Promise<TestLink> {
    const formData = new FormData();
    formData.append('name',  data.name);
    formData.append('startDate',  new Date(data.startDate).toISOString());
    formData.append('finishDate',  new Date(data.finishDate).toISOString());
    formData.append('isMixedQuestions', data.isMixedQuestions.toString());
    formData.append('isMixedOptions', data.isMixedOptions.toString());
    formData.append('allQuestionsRequired', data.allQuestionsRequired.toString());
    formData.append('trackTelegramUsers', data.trackTelegramUsers.toString());

    return this.http.put<TestLink>(`api/tests/${testId}/links/${testLinkId}`, formData)
      .toPromise();
  }
}
